<template>
	<div>
		<CCard>
			<CCardHeader>
				<p>
					Client -
					<router-link :to="`/clients/${customer.id}/edit`">
						<span>
							<template v-if="order.senderAddress">
								{{ order.senderAddress.firstName }} {{ order.senderAddress.lastName }}
							</template>
							<template v-else>
								{{ customer.email }}
							</template>
							#{{ customer.id }}
						</span>
					</router-link>
				</p>
			</CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="12">
						<h5>Email :</h5>
						<p>{{ customer.email }}</p>
					</CCol>
					<CCol col="12">
						<h5>Nbr de commandes :</h5>
						<p>{{ customer.countOrders }}</p>
					</CCol>
				</CRow>
				<CRow>
					<CCol col="12">
						<h5>Date création :</h5>
						<p>{{ $moment(customer.createdAt).format('DD/MM/YYYY HH:mm') }}</p>
					</CCol>
					<CCol col="12">
						<h5>N° client :</h5>
						<p>{{ customer.userCode }}</p>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard>
			<CCardHeader> Adresse d'expédition </CCardHeader>
			<CCardBody>
				<CRow>
					<CCol sm="12" v-if="order.senderAddress">
						<span v-if="order.senderAddress.companyName">
							{{ order.senderAddress.companyName }} <br />
						</span>

						<span class="font-weight-bold">
							{{ order.senderAddress.firstName }} {{ order.senderAddress.lastName }} <br />
						</span>

						{{ order.senderAddress.address }} <br />
						<span v-if="order.senderAddress.address2"
							>{{ order.senderAddress.address2 }} <br
						/></span>

						{{ order.senderAddress.city }} {{ order.senderAddress.postalCode }} <br />

						{{ order.senderAddress.country.name }} <br />

						{{ order.senderAddress.phone }}
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	export default {
		props: {
			order: Object,
			customer: Object,
		},
	};
</script>
